import { TESTIMONIALS } from '@/app/lib/testimonials';

// Home-page testimonial strip. Ships dark: renders nothing until real
// quotes are added to app/lib/testimonials.ts.
export default function Testimonials() {
  if (TESTIMONIALS.length === 0) return null;

  return (
    <div className="w-full max-w-4xl grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 text-left">
      {TESTIMONIALS.slice(0, 3).map((t, i) => (
        <figure key={i} className="bg-[#0f172a]/60 border border-amber-500/20 rounded-2xl p-5">
          <blockquote className="text-slate-300 text-sm leading-relaxed">“{t.quote}”</blockquote>
          <figcaption className="mt-3 text-xs font-bold text-amber-400/80 uppercase tracking-wider">
            {t.name} · {t.location}
          </figcaption>
        </figure>
      ))}
    </div>
  );
}
